import { Grid } from '@mui/material';
import React, { useContext } from 'react'
import styles from "../../../../../assets/styles/componentStyles/chats/smartAssist.module.scss";
import { dataConnectorList } from '../../../../../models/axiosModel';
import { fontColorForMethod, hasUserLoggedInPermission } from '../../../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';

interface SmartAssistCardProps {
    item: dataConnectorList,
    onRunTool: (item: dataConnectorList) => void,
}

const SmartAssistCard: React.FC<SmartAssistCardProps> = (props) => {

    const { item, onRunTool } = props;

    const { apiRoutesPermissionAssignment, userDetail } = useContext(UserContext) as UserContextPayload

    return (
        <Grid item className={styles.smartAssistCard}>
            <Grid container className={styles.smartAssistCardHeader}>
                <Grid item className={styles.smartAssistCardTitle} title={item?.data_connector_functions?.data_connector_function_name}>
                    {item?.data_connector_functions?.data_connector_function_name}
                </Grid>
                <Grid className={`${styles.smartAssistMethodBadge}`} style={{ backgroundColor: `${fontColorForMethod(item?.function_method_name)}1A`, color: `${fontColorForMethod(item?.function_method_name)}` }}>
                    {item?.function_method_name}
                </Grid>
            </Grid>
            <div className={styles.smartAssistCardDescription} title={item?.data_connector_functions?.data_connector_function_description}>
                {item?.data_connector_functions?.data_connector_function_description}
            </div>
            {hasUserLoggedInPermission(apiRoutesPermissionAssignment, userDetail) && 

                <>
                    <Grid item onClick={() => onRunTool(item)} className={styles.runToolBtn}>
                        Run Tool
                    </Grid>
                </>
            }
        </Grid>
    )
}

export default SmartAssistCard
